import { ia, pm } from 'lib/helpers/utility';

export const checkOptionPermission = (permissions) => (option) => {
  if (!option?.permission) return true;

  const { isAny, requiredPermissions } = option.permission;

  if (!requiredPermissions || !ia(requiredPermissions)) return true;

  if (isAny) return pm(permissions, requiredPermissions, 'or');
  else return pm(permissions, requiredPermissions);
};
